/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Update current and canonical URL
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateUrls(response) {
    let $canonicalLink = $("link[rel^='canonical']");
    let $prevLink = $("link[rel^='prev']");
    let $nextLink = $("link[rel^='next']");
    let $permaLinkUrl = null;

    let $nextUrl = $(".next").val();
    let $prevUrl = $(".prev").val() === "null" ? null : $(".prev").val();

    if (response) {
        $permaLinkUrl = $(".permalink", response).val();
    } else {
        $permaLinkUrl = window.location.href;
    }

    if ($permaLinkUrl) {
        let $permalink = $permaLinkUrl;

        let $canonicalUrl = $permalink;

        $canonicalLink.attr("href", $canonicalUrl);

        // set current URL
        window.history.pushState(null, null, $permalink);
    }

    if ($nextUrl) {
        $nextLink.attr("href", $nextUrl);
    }

    if ($prevUrl) {
        if ($prevLink.length > 0) {
            $prevLink.attr("href", $prevUrl);
        } else {
            $nextLink.after(
                `<link rel="prev" href="${$prevUrl}" />`
            );
        }
    }
}

/**
 * Parse query string
 *
 * @param {string} query - permalink
 * @return {Object} - return object with page size
 */
// function parseQueryString(query) {
//     var vars = query.split('&');
//     var queryString = {};
//     for (var i = 0; i < vars.length; i++) {
//         var pair = vars[i].split('=');
//         var key = decodeURIComponent(pair[0]);
//         var value = decodeURIComponent(pair[1]);
//         if (typeof queryString[key] === 'undefined') {
//             queryString[key] = decodeURIComponent(value);
//         } else if (typeof queryString[key] === 'string') {
//             var arr = [queryString[key], decodeURIComponent(value)];
//             queryString[key] = arr;
//         } else {
//             queryString[key].push(decodeURIComponent(value));
//         }
//     }
//     return queryString;
// }

/**
 * scroll horizontally (categories on plp)
 */
/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} target - scrolling element target
 * @return {undefined}
 */
const scrollHorizontally = (target) => {
    const element = document.querySelector(target);


    if (element) {
        element.addEventListener("wheel", (event) => {
            event.preventDefault();
            const isTouchPad = event.wheelDeltaY ? event.wheelDeltaY === -3 * event.deltaY : event.deltaMode === 0;

            if (!isTouchPad) {
                element.scrollBy({
                    left: event.deltaY < 0 ? -30 : 30
                });
            } else {
                element.scrollBy({
                    left: event.deltaX < 0 ? -30 : 30
                });
            }
        });
    }
};
scrollHorizontally(".cat-first > .scroll-horizontally");

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $(".refinement.active").each(function () {
        $(this).removeClass("active");
        var activeDiv = $results.find("." + $(this)[0].className.replace(/ /g, "."));
        $(".refinement.sort-order-menu").addClass("active");
        activeDiv.addClass("active");
        activeDiv.find("button.title").attr("aria-expanded", "true");
    });
    updateDom($results, ".refinements");
    if ($(".refinements").text() === "") {
        $(".refinement-bar button.close").trigger("click");
        $(".grid-header__bottom").addClass("d-none");
        $(".content-body").removeClass("pt-3 pt-lg-5").addClass("pt-0 pt-lg-0");
    }
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        ".refinements": handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        ".grid-header__top",
        ".footer-bar",
        ".product-grid",
        ".show-more",
        ".filter-bar",
        ".view-all",
        ".sub-categories__list",
        ".content-body"

    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @return {undefined}
 */
function getContent($element, $target) {
    var showMoreUrl = $element.data("url");
    $.spinner().start();
    $.ajax({
        url: showMoreUrl,
        method: "GET",
        success: function (response) {
            $target.append(response);
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}
/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function updateSortOptions(response) {
    var $tempDom = $("<div>").append($(response));

    if ($(".grid-footer").length > 0) {
        var sortOptions = $tempDom.find(".grid-footer").data("sort-options").options;

        $(".search-refinement-panel").removeClass("d-none");
        sortOptions.forEach(function (option) {
            $("input." + option.id).val(option.url);
        });
    } else {
        $(".search-refinement-panel").addClass("d-none");
    }
}

module.exports = {
    initPage: function () {
        updateUrls();
    },

    filter: function () {
        // Display refinements bar when Menu icon clicked
        $(".container").on("click", "button.filter-results", function () {
            $(".refinement-bar").addClass("open-refinement-bar");
            $(".modal-background").fadeIn();
            $(".refinement-bar").siblings().attr("aria-hidden", true);
            $(".refinement-bar").closest(".row").siblings().attr("aria-hidden", true);
            $(".refinement-bar").closest(".tab-pane.active").siblings().attr("aria-hidden", true);
            $(".refinement-bar").closest(".container.search-results").siblings().attr("aria-hidden", true);
        });
    },

    closeRefinements: function () {
        // Refinements close button
        $("body").on("click", ".refinement-bar button.close, .modal-background, .refinement-bar button.view-all", function () {
            $(".refinement-bar").removeClass("open-refinement-bar");
            $(".modal-background").fadeOut();
            $(".refinement-bar").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".row").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".tab-pane.active").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".container.search-results").siblings().attr("aria-hidden", false);
        });
    },

    resize: function () {
        // Close refinement bar and hide modal background if user resizes browser
        $(window).resize(function () {
            $(".refinement-bar").removeClass("open-refinement-bar");
            $(".modal-background").fadeOut();
            $(".refinement-bar").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".row").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".tab-pane.active").siblings().attr("aria-hidden", false);
            $(".refinement-bar").closest(".container.search-results").siblings().attr("aria-hidden", false);
        });
    },

    sort: function () {
        // Handle sort order menu selection
        $(".container").on("click", "[name=sort-order]", function (e) {
            e.preventDefault();
            $.spinner().start();

            var activeItem = $(".sort-order-menu").find(".active-item");
            var buttonLi = $(this).closest("li");

            if (activeItem.length > 0 && !$(buttonLi).hasClass("active-item")) {
                $(activeItem).removeClass("active-item");
                $(buttonLi).addClass("active-item");
                sessionStorage.setItem("sortOption", $(this).attr("class"));
            } else if ($(buttonLi).hasClass("active-item")) {
                $(buttonLi).removeClass("active-item");
                sessionStorage.removeItem("sortOption");
            } else {
                $(buttonLi).addClass("active-item");
                sessionStorage.setItem("sortOption", $(this).attr("class"));
            }
            $(this).trigger("search:sort", this.value);

            $.ajax({
                url: this.value,
                data: { selectedUrl: this.value },
                method: "GET",
                success: function (response) {
                    $(".product-grid").empty().html(response);
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    showMore: function () {
        // Show more products
        $(".container").on("click", ".show-more button", function (e) {
            e.stopPropagation();
            e.preventDefault();

            var showMoreUrl = $(this).data("url");
            sessionStorage.removeItem("windowLocation");
            sessionStorage.removeItem("catPathname");
            sessionStorage.removeItem("productPid");

            $.spinner().start();
            $(this).trigger("search:showMore", e);

            $.ajax({
                url: showMoreUrl,
                data: { selectedUrl: showMoreUrl },
                method: "GET",
                success: function (response) {
                    $(".grid-footer").replaceWith(response);
                    updateUrls(response);
                    updateSortOptions(response);

                    // Insert marketing tiles every n products
                    marketTiles.init();
                    module.exports.setNavHistory();

                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },

    applyFilter: function () {
        // Handle refinement value selection and reset click
        $(".container").on(
            "click",
            ".refinements li button, .refinement-bar button.reset, .filter-selected button, .swatch-filter button, .filter-bar button.reset, .all-products-wrapper button.all-products",
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                var element = $(this);

                $.spinner().start();
                $(this).trigger("search:filter", e);
                let filtersLength;

                $.ajax({
                    url: $(this).data("href"),
                    data: {
                        page: $(".grid-footer").data("page-number"),
                        selectedUrl: $(this).data("href"),
                        target: $(this).parent().hasClass("filter-selected") || $(this).hasClass("reset"),
                    },
                    method: "GET",
                    success: function (response) {
                        parseResults(response);
                        updateUrls(response);
                        updateSortOptions(response);

                        $.spinner().stop();

                        let buttonRoot = $(".filter-selected button[data-href*=\"root\"]");
                        let btnSort = $(".refinement-sort .active-item");
                        let $sortOption = sessionStorage.getItem("sortOption");

                        if (btnSort.length > 0) {
                            btnSort.removeClass("active-item");
                        }

                        if (buttonRoot.length > 0) {
                            filtersLength = $(".filter-selected").length - 1;
                        } else {
                            filtersLength = $(".filter-selected").length;
                        }

                        if (filtersLength > 0) {
                            if (!(element.parent().hasClass("filter-selected") || element.hasClass("reset"))) {
                                $(".modal-background").css("display", "block");
                            }
                            $(".nbr-filters").text("(" + filtersLength + ")");
                            $(".reset-link").fadeIn();
                            if ($sortOption !== null) {
                                $("." + $sortOption).closest("li").addClass("active-item");
                            }
                            $(".filter-bar .reset-link").fadeIn();
                            $("li.active-item").each(function () {
                                $(this).closest(".refinement").addClass("active");
                            });
                        } else {
                            $(".refinement-bar").removeClass("open-refinement-bar");
                            $(".nbr-filters").text("");
                            $(".reset-link").fadeOut();
                            sessionStorage.removeItem("reapplyFilters");
                            sessionStorage.removeItem("filtersApplied");
                            sessionStorage.removeItem("sortOption");
                            $(".modal-background").fadeOut();
                        }

                        scrollHorizontally(".cat-first > .scroll-horizontally");

                        $(".tab-content").removeClass("invisible");
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        );
    },

    applyFilterCat: function () {
        // Handle subcategories value selection
        $(document).on(
            "click",
            ".sub-categories__list li button, .sub-categories__list .values li button",
            function (e) {
                e.preventDefault();
                e.stopPropagation();

                $.spinner().start();
                $(this).trigger("search:filter", e);

                let listItem = $(this).parent("li");
                let attributeId = "#" + $(this).find("span").last().attr("id");

                $.ajax({
                    url: $(this).data("href"),
                    data: {
                        page: $(".grid-footer").data("page-number"),
                        selectedUrl: $(this).data("href")
                    },
                    method: "GET",
                    success: function (response) {
                        parseResults(response);
                        updateUrls(response);
                        updateSortOptions(response);

                        $.spinner().stop();
                        $(attributeId).parent("button").focus();
                        $(listItem).addClass("is-active");

                        let filtersLength = $(".filter-selected").length;

                        if (filtersLength > 0) {
                            $(".nbr-filters").text("(" + filtersLength + ")");
                            $(".reset-link").fadeIn();
                        }

                        if ($(".slider-recommendations").length > 0) {
                            $(".grid-header").removeClass("border-bottom").addClass("no-results justify-content-start");
                            recosSlider.init();
                        }

                        scrollHorizontally(".cat-first > .scroll-horizontally");
                        $(".tab-content").removeClass("invisible");
                    },
                    error: function () {
                        $.spinner().stop();
                        $(attributeId).parent("button").focus();
                    }
                });
            }
        );
    },

    showContentTab: function () {
        // Display content results from the search
        $(".container").on("click", ".content-search", function () {
            if ($("#content-search-results").html() === "") {
                getContent($(this), $("#content-search-results"));
            }
        });

        // Display the next page of content results from the search
        $(".container").on("click", ".show-more-content button", function () {
            getContent($(this), $("#content-search-results"));
            $(".show-more-content").remove();
        });
    },

    initAppliedFilters: function () {
        let doNotPushHistory = false;
        let $filters = sessionStorage.getItem("filtersApplied");
        let $sortOption = sessionStorage.getItem("sortOption");

        /**
         * Listen to all possible AJAX calls on a search page
         */
        $(document).ajaxSuccess(
            function (event, xhr) {
                if (xhr.responseText.indexOf("<div class=\"product-tile\">") >= 0) {
                    if (!doNotPushHistory) {
                        setTimeout(function () {
                            let filtersApplied = decodeURI($(".permalink").val().split("?")[1]);
                            filtersApplied = filtersApplied.replace(/&{0,1}start.*&sz.+?(?=&|$)/g, "");

                            sessionStorage.setItem("filtersApplied", filtersApplied);
                            sessionStorage.setItem("reapplyFilters", true);
                            sessionStorage.setItem("pid", $(".page").data("querystring"));
                        });
                    }

                    doNotPushHistory = false;
                }
            }
        );
        /**
         * Retrieve all filters applied
         */
        $(document).ready(function () {
            const $resetButton = $(".refinement-bar button.reset");
            const $resetUrl = $resetButton.data("href");
            const $pid = $(".page").data("querystring");
            const $newResetUrl = $resetUrl + "?" + $pid + "&" + sessionStorage.getItem("filtersApplied");

            if ($filters !== null) {
                doNotPushHistory = true;
                $resetButton.data("href", decodeURI($newResetUrl));
                $resetButton.trigger("click");
            } else {
                sessionStorage.removeItem("pid");
                sessionStorage.removeItem("reapplyFilters");
                sessionStorage.removeItem("filtersApplied");
                sessionStorage.removeItem("sortOption");
                $("." + $sortOption).closest(".best-matches-btn").removeClass("active-item");
                $(".filter-bar .reset-link").fadeOut();
                $(".tab-content").removeClass("invisible");
            }
        });
    },

    setNavHistory: function () {
        var windowLocation;
        var catPathname;
        var productPid;

        $(".product-tile").on("click", "a", function () {
            catPathname = window.location.pathname;
            // Modify the current url to have the complete catalog
            var url = new URL(window.location);
            var queryString = url.search;
            var urlParams = new URLSearchParams(queryString);
            if (urlParams.has("sz")) {
                var size = parseInt(urlParams.get("sz"), 10);
                urlParams.set("sz", size);
                url.search = urlParams.toString();
            }
            windowLocation = url.href;
            productPid = $(this).closest(".product").attr("data-pid");

            sessionStorage.setItem("windowLocation", windowLocation);
            sessionStorage.setItem("catPathname", catPathname);
            sessionStorage.setItem("productPid", productPid);

            // window.history.pushState({ page: 'previous PLP' }, document.title, url.href);
        });

        if (sessionStorage.getItem("catPathname") !== window.location.pathname) {
            sessionStorage.removeItem("windowLocation");
            sessionStorage.removeItem("catPathname");
            sessionStorage.removeItem("productPid");
        }

        if (sessionStorage.getItem("windowLocation") !== null && windowLocation !== sessionStorage.getItem("windowLocation")) {
            $(document).ready(function () {
                var productTile = $(".product[data-pid=" + sessionStorage.getItem("productPid") + "]");
                if (productTile.offset()) {
                    var scrollToProd = productTile.offset().top;

                    $(".tab-content").removeClass("invisible");

                    $("html, body").animate(
                        {
                            scrollTop: scrollToProd
                        },
                        750
                    );
                }
            });
        }
    }
};
/**
 * insert marketing tiles on "show more" click
 *
 */
const marketTiles = {
    init() {
        const marketingTiles = $(".promo-region").find("[data-id^=productListTile-]");
        const productsLength = $(".region-product").length;

        for (var i = 0; i < marketingTiles.length; i++) {
            const marketingTile = $(marketingTiles[i]);
            const dataRec = $(marketingTile).closest(".promo-region").data("rec");
            const pageSize = Number($(".grid-footer").data("page-size"));
            const pageNbr = $(".grid-footer").data("page-number");

            for (var j = (pageSize * pageNbr); j < productsLength; j++) {
                if (j % dataRec === 0) {
                    var marketingRegion = $(marketingTile).closest(".promo-region");
                    $(marketingRegion).clone().insertAfter($(".region-product").eq(j)).removeClass("promo-region");
                }
            }
        }
    }
};

const recosSlider = {
    init() {
        $(".slider-recommendations").slick({
            infinite: true,
            cssEase: "linear",
            slidesToShow: 4,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        infinite: true,
                        cssEase: "linear",
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        infinite: true,
                        cssEase: "linear",
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        dots: true
                    }
                }
            ]
        });
    }
};
